import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/sustainability/Climate.png")